import { h, Component } from 'preact'
import TopicListItem from '../topic-list-view/TopicListItem'
import axios from 'axios'
import TopicListItemView, { TopicInfo } from '../topic-list-view/TopicListItemView'
import { common } from '../common'
import Phrase from '../../libs/translationsUtils/phrase'

interface Props {
  eventId: number,
  attachmentCdn: string
}

interface State {
  topics: TopicInfo[],
  error: boolean
}

class FeaturedTopicsListAsSearchResults extends Component<Props, State> {
  private isGuest = !window.inSidedData.user.userid
  isNewTopicListViewEnabled: boolean

  constructor (props: Props) {
    super(props)
    this.isNewTopicListViewEnabled = common.isModuleActive('topicItemView')
    this.state = {
      topics: [],
      error: false
    }
  }

  async componentDidMount () {
    await this.loadTopics();
  }

  private async loadTopics() {
    this.setState({ error: false })
    try {
      const res = await axios.get(`/events/${this.props.eventId}/featuredTopics`)
      this.setState({ topics: res.data })
    } catch (err) {
      this.setState({ error: true })
    }
  }

  render ({ attachmentCdn, eventId }: Props, { error, topics }: State) {
    if (error) return <div className='event-featured-topics-error-container' id='featured-topics'>
      Something went wrong, we have troubles displaying topics.
      Please <a href='#featured-topics' onClick={() => this.loadTopics()}>try again</a>.
    </div>

    if (topics.length == 0) return null

    return <div class='event-featured-topics-container'>
      <div className='event-attendees__header_label'><Phrase p='events.featured.topics' /></div>
      {
        topics.map((topic: TopicInfo) => !this.isNewTopicListViewEnabled
          ? <TopicListItem isGuest={this.isGuest} topic={topic} attachmentCdn={attachmentCdn} />
          : <TopicListItemView isGuest={this.isGuest} hideCategoryMetadata={false} topic={topic} attachmentCdn={attachmentCdn} clickCallback={() => {}} />)
      }
    </div>
  }
}

export default FeaturedTopicsListAsSearchResults
